<section class="row clearfix" *ngIf="editable || data.enable"
[class.odd]="data.index % 2  == 0"
[class.bg-color2]="data.index === 0 || data.index === 5 || data.index === 8">
  <div class="col-md-12" *ngIf="editable">
    <app-index-controller [data]="data">
      <li>
        <select class="form-control" name="{{data.uuid}}_path" [(ngModel)]="data.path" (ngModelChange)="dataSourceChange($event)" appLock #dataSourceLock="lock" [disabled]="dataSourceLock.isLock">
          <option [ngValue]="undefined">請選擇來源選單</option>
          <ng-container *ngFor="let menu of dataSourceOptions">
            <option [ngValue]="menu.path" >{{menu.title}}</option>
          </ng-container>
        </select>
      </li>
    </app-index-controller>
  </div>
  <div class="col-lg-10 offset-lg-1 col-md-12">
    <div class="article_59">
      <div class="cont-tit">
        <h2 [tmWow]="data.wowSetting" *ngIf="editable || data['title']">
          <span [attr.contenteditable]="editable" [(tmContenteditableModel)]="data.title" (tmContenteditableModelChange)="keepConnection()"
          appEditableContentPlaceholder="請輸入標題"></span>
        </h2>
				<ul class="nav nav-tabs nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="article_59_pills_0-tab" type="button" role="tab"
            data-bs-toggle="pill" data-bs-target="#article_59_pills_0" aria-controls="article_59_pills_0" aria-selected="true">全部</button>
          </li>
          <ng-container *ngIf="categories?.length">
            <ng-container *ngFor="let category of categories; let i = index">
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="article_59_pills_{{i + 1}}-tab" type="button" role="tab"
                data-bs-toggle="pill" attr.data-bs-target="#article_59_pills_{{i + 1}}" attr.aria-controls="article_59_pills_{{i + 1}}" attr.aria-selected="{{i === 0 ? 'true' : 'false'}}">{{category}}</button>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
      <div class="p-h-lg clear">
				<div class="tab-content" id="pills-tabContent">
          <ng-container *ngTemplateOutlet="dataTmp; context: {$implicit: remoteData, index: 0}"></ng-container>

          <ng-container *ngIf="categories?.length">
            <ng-container *ngFor="let category of categories; let i = index">
              <ng-container *ngTemplateOutlet="dataTmp; context: {$implicit: listGroupedByCategory[category], index: i+1}"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #dataTmp let-rows let-i="index">
  <div class="tab-pane fade" id="article_59_pills_{{i}}" #tabPane
  role="tabpanel" attr.aria-labelledby="article_59_pills_{{i}}-tab">
    <div class="row p-h-xs">
      <div class="col-left">
        <div class="aside-box clearfix">
          <ng-container *ngIf="rows.length > 0">
            <a [routerLink]="data.path && rows[0].id ? toHomePath + '/' + data.path + '/' + rows[0].id : './'"
            title="{{rows[0].title}}{{data.path && rows[0].id ? ('[' + ('openNewWindow' | translate) + ']') : ''}}"
            target="{{data.path && rows[0].id ? '_blank' : ''}}" [tabindex]="data.path && rows[0].id ? 0 : -1" [class.disableClick]="editable"> 
              <div class="image-wrap rounded-4">
                <img src="{{rows[0].images && rows[0].images[0] ? (rows[0].images[0] | transform:'comp') : '/assets/images/v001/no-images2.webp'}}"
                alt="{{rows[0].images && rows[0].images[0] ? rows[0].images[0].name : ''}}"
                class="fit_cover" tmObjectFit="cover" imgSrc="{{rows[0].images && rows[0].images[0] ? (rows[0].images[0] | transform:'comp') : '/assets/images/v001/no-images2.webp'}}"
                tmErrorDefaultImage="/assets/images/v001/no-images2.webp"
                [lazyLoading]="data.index >= 2"
                [tmWow]="data.wowSetting">
              </div>
              <div class="details">
                <div class="cont">{{rows[0].openStartDate | date: 'yyyy-MM-dd'}}</div>
                <div class="title">{{rows[0].title}}</div>
              </div>
            </a>
          </ng-container>
          <ng-container *ngIf="!rows.length">
            <p class="nodata-hint text-center">選單未設定資料</p>
          </ng-container>
        </div>
      </div>
      <div class="col-right">
        <ng-container *ngFor="let rd of (rows | slice:1:4); let i = index">
          <div class="">
            <div class="aside-box clearfix">
              <a [routerLink]="data.path && rd.id ? toHomePath + '/' + data.path + '/' + rd.id : './'"
              title="{{rd.title}}{{data.path && rd.id ? ('[' + ('openNewWindow' | translate) + ']') : ''}}"
              target="{{data.path && rd.id ? '_blank' : ''}}" [tabindex]="data.path && rd.id ? 0 : -1" [class.disableClick]="editable"> 
                <div class="image-wrap rounded-4">
                  <img src="{{rd.images && rd.images[0] ? (rd.images[0] | transform:'comp') : '/assets/images/v001/no-images2.webp'}}"
                  alt="{{rd.images && rd.images[0] ? rd.images[0].name : ''}}"
                  class="fit_cover" tmObjectFit="cover" imgSrc="{{rd.images && rd.images[0] ? (rd.images[0].transform | transform:'comp') : '/assets/images/v001/no-images2.webp'}}"
                  tmErrorDefaultImage="/assets/images/v001/no-images2.webp"
                  [lazyLoading]="data.index >= 2"
                  [tmWow]="data.wowSetting">
                </div>
                <div class="details">
                  <div class="cont">{{rd.openStartDate | date: 'yyyy-MM-dd'}}</div>
                  <div class="title">{{rd.title}}</div>
                </div>
              </a>
            </div>
          </div>
        </ng-container>

        <div class="btn-more" [class.disableClick]="editable">
          <a routerLink="./{{data.path}}" title="{{data.menuLabel ? (data.menuLabel + '[' + ('openNewWindow' | translate) + ']') : ''}}"
          target="{{data.path ? '_blank' : ''}}" [tabindex]="data.path ? 0 : -1">
            <button class="btn btn-brown cta-plus"><i class="fa fa-plus" aria-hidden="true"></i>{{'more2' | translate}}</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>